// ─── Common ──────────────────────────────────────────────────────────────────
export * from './keno.js';
/** Narrow a login answer without repeating the shape check in every caller. */
export function isLoginOtpRequired(r) {
    return r.otpRequired === true;
}
/**
 * Every bet type, as a value rather than a type — for zod enums, pill rows and any
 * other place that needs to iterate them.
 *
 * Kept here because the list was already written out separately in the API's zod schema
 * and in the admin's ปิดรับเลข screen, and a third copy was about to appear. When those
 * copies drift, a number becomes blockable on one screen and not another, which is the
 * kind of bug nobody finds until an operator is on the phone.
 */
export const DRAW_BET_TYPES = [
    '3top', '3tote', '2top', '2bottom',
    '3front', '3bottom',
    'run_top', 'run_bottom',
    'odd_even_top', 'high_low_top',
    'odd_even_bottom', 'high_low_bottom',
];
/**
 * How long a number is for each bet type. The choice types take a keyword instead of
 * digits, so they carry 0 — a caller validating input branches on that.
 */
export const DRAW_BET_TYPE_DIGITS = {
    '3top': 3, '3tote': 3,
    '3front': 3, '3bottom': 3,
    '2top': 2, '2bottom': 2,
    run_top: 1, run_bottom: 1,
    odd_even_top: 0, high_low_top: 0,
    odd_even_bottom: 0, high_low_bottom: 0,
};
// ── ประวัติการอั้นเลข — the trail of every change to a number limit ───────────────
/**
 * The audit actions that count as "อั้นเลข". Kept here because the SQL filter, the index
 * predicate in migration 064 and the screen's action picker must all name the same set —
 * a code in one list and not another is an entry that is recorded and never shown.
 *
 * draw.payout.update is deliberately absent: a bet type's payout rate is its own screen
 * (อัตราจ่าย), and folding it in here would bury the number changes someone came to find.
 */
export const NUMBER_LIMIT_ACTIONS = [
    'draw.number.block',
    'draw.number.unblock',
    'draw.number_cap.set',
    'draw.number_cap.delete',
    'draw.limits.update',
    'partner.number_rule.set',
    'partner.number_rule.delete',
    'partner.number_rule.clear',
];
// ─── Draw scheduling (shared by api + worker) ────────────────────────────────
export { computeNextDrawAt, drawWindow, drawDateOf, normalizeRounds, nextDrawSlot, nextDrawSlots, slotCloseBeforeSeconds, slotOpenBeforeSeconds, slotOpenAfterPreviousSeconds, } from './draw-schedule.js';
// ─── Price-game display/settlement precision (shared by api + worker + web) ──
export { DEFAULT_PRICE_DECIMALS, priceDecimalsFor, roundPriceDisplay, lastDisplayedDigit, } from './price-display.js';
// ─── Admin permissions (shared by api + admin console) ───────────────────────
export { PERMISSION_MENUS, ALL_PERMISSION_KEYS, hasPermission, canSeeMenu, isPermissionKey, } from './permissions.js';
//# sourceMappingURL=index.js.map